import BatterTableDataView from "@/components/BatterTableDataView.vue";
import api from "@/api";
import { ElLoading } from "element-plus";
export default {
  name: "SitePageStatistic",
  components: {
    BatterTableDataView
  },
  props: {
    site: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    exportAsXlsx() {
      let loading = ElLoading.service({
        lock: true,
        text: '请稍等...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      api.exportPageStatistic(this.site.value).then(ret => {
        window.open(ret, '_blank');
        loading.close();
      });
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};